import { Component, OnInit, ViewChild } from '@angular/core';
import { GetDeleteTimesheetService } from '../Services/get-delete-timesheet.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { CalendarModule } from 'primeng/calendar';

interface GetDeleteTimeSheet {
  projectID: number;
  ProjectName: string;
  taskID: number;
  TaskName: string;
  timeCode: number;
  userID: number;
  isBillable: string;
  isDataSync: string;
  startWeek: Date;
  endWeek: Date;
  TimesheetDate: string;
  hours: number;
  comments: string;
  RecordStatus: string;
  TimeSheetReturnId:string;
}

@Component({
  selector: 'app-get-delete-timesheet',
  templateUrl: './get-delete-timesheet.component.html',
  styleUrls: ['./get-delete-timesheet.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class GetDeleteTimesheetComponent implements OnInit {

  @ViewChild('dt') dt!: Table;

  searchForm!: FormGroup;
  timesheets: GetDeleteTimeSheet[] = [];
  isLoading = false;
  hasSearched = false;
  showLoader: boolean = false;

  constructor(private fb: FormBuilder, private getDeleteTimesheetService: GetDeleteTimesheetService, private messageService: MessageService,private dialogService: DialogService,
    private confirmationService: ConfirmationService) {
  }

  ngOnInit(): void {
    this.searchForm = this.fb.group(
      {
        startDate: [null, Validators.required],
        endDate: [null, Validators.required]
      },
      { validators: this.dateRangeValidator }
    );
  }

  dateRangeValidator(group: FormGroup) {
    const start = group.get('startDate')?.value;
    const end   = group.get('endDate')?.value;
    if (start && end && new Date(start) > new Date(end)) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  onSearch(): void {
    this.showLoader= true;
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      this.showLoader= false;
      return;
    }
 
    this.isLoading   = true;
    this.hasSearched = true;
 
    const { startDate, endDate } = this.searchForm.value;
 
    this.getDeleteTimesheetService.GetTimeSheet(new Date(startDate), new Date(endDate)).subscribe({
      next: (data) => {
        this.timesheets = data.Data;
        this.showLoader= false;
        this.isLoading  = false;
      },
      error: (err) => {
        this.showLoader= false;
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch timesheet records. Please try again.',
          life: 5000
        });
        console.error(err);
      }
    });
  }
 
  onReset(): void {
    this.searchForm.reset();
    this.timesheets  = [];
    this.hasSearched = false;
  }
 
  confirmDelete(record: GetDeleteTimeSheet): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete the timesheet entry for
                <strong>${record.ProjectName}</strong> — <strong>${record.TaskName}</strong>
                on <strong>${record.TimesheetDate}</strong>?`,
                // <br><br><small style="color:#dc2626">This action cannot be undone.</small>`,
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-outlined p-button-secondary',
      accept: () => this.executeDelete(record)
    });
  }

    private executeDelete(record: GetDeleteTimeSheet): void {
    this.getDeleteTimesheetService.deleteTimesheet(record.TimeSheetReturnId)
      .subscribe({
        next: () => {
          this.timesheets = this.timesheets.filter(t => t !== record);
          this.messageService.add({
            severity: 'success',
            summary: 'Deleted',
            detail: `Timesheet for "${record.ProjectName} — ${record.TaskName}" deleted successfully.`,
            life: 4000
          });
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to delete the record. Please try again.',
            life: 5000
          });
          console.error(err);
        }
      });
  }
}
